import { gql } from '@apollo/client';

export const GET_CLARIFICATION_SCHEMAS_LIST = gql`
  query ClarificationSchemas($params: FindClarificationSchemaListInput!) {
    clarificationSchemas(params: $params) {
      success
      message
      errors
      data {
        schemas {
          id
          entity
          matchEntities
          type
          relatedEntities
          finalQueryTemplate
          personKeywords
          description
          triggerKeywords
          maxResultsWithoutClarification
          parentSchemaId
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
        hasMorePages
        nextPage
        totalPages
        totalRecords
      }
    }
  }
`;

export const GET_CLARIFICATION_SCHEMA = gql`
  query ClarificationSchema($params: FindClarificationSchemaInput!) {
    clarificationSchema(params: $params) {
      success
      message
      errors
      data {
        id
        entity
        matchEntities
        type
        relatedEntities
        finalQueryTemplate
        personKeywords
        description
        triggerKeywords
        maxResultsWithoutClarification
        parentSchemaId
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;
